import { createReducer, on } from '@ngrx/store';
import { AppSettingsState } from 'src/app/models/state/app-settings-state.model';
import { AppSettingsActions } from '../actions/app-settings.actions';
import { get, save } from 'src/app/data/utils/localstorage.util';

const ROUTING_KEY = 'AppSettingsState';

export const initialState: AppSettingsState = {
	isGeolocationEnabled: false,
};

const getInitialState = (initialState): AppSettingsState => {
	const stateFromLocalStorage = get<AppSettingsState>(ROUTING_KEY);
	if (stateFromLocalStorage !== null) {
		return stateFromLocalStorage;
	}

	return initialState;
};

export const appSettingsReducer = createReducer(
	getInitialState(initialState),
	on(
		AppSettingsActions.addIsGeolocationEnabled,
		(state, { isGeolocationEnabled }): AppSettingsState => {
			const newState: AppSettingsState = {
				...state,
				isGeolocationEnabled,
			};
			saveSateToLocalStorage(newState);
			return newState;
		}
	)
);

function saveSateToLocalStorage(newState: AppSettingsState) {
	save(ROUTING_KEY, newState);
}
